<template>
  <div class="admin-card bg-white p-4 h-100">
    <div class="text-muted small text-uppercase font-weight-bold mb-2">{{ label }}</div>
    <div class="display-4 font-weight-bold text-primary mb-2">{{ value }}</div>
    <div class="text-secondary">{{ hint }}</div>
  </div>
</template>

<script>
export default {
  name: "StatCard",
  props: {
    label: String,
    value: [String, Number],
    hint: String
  }
};
</script>

